import { ApolloLink } from '@apollo/client';
import type { Operation, NextLink } from '@apollo/client';
import { isRefreshTokenProvided } from 'utils/token';
import { logger } from 'modules/logger';

/** GraphQL operations that do not require authentication to execute. */
const AUTHLESS_OPERATIONS = [
  'authenticate',
  'authWithExtToken',
  'requestPasswordReset',
  'resetPassword',
  'authenticateMFA',
  'confirmAccount',
];

/**
 * Skips operations that require auth when no refresh token is present.
 */
export const requiresAuthMiddleware = new ApolloLink((operation: Operation, forward: NextLink) => {
  if (AUTHLESS_OPERATIONS.includes(operation.operationName) || isRefreshTokenProvided()) {
    return forward(operation);
  }

  logger.info(`[Apollo Client]: Unauthenticated, skipping '${operation.operationName}'`);
  return null;
});
